import { httpClient } from "@/services";

export const saveSafetyInformation = async(endpoint, values) => {
	console.log('%c [  values  ] ', 'color:#bada55', typeof values, values );
	const { data } = await httpClient.post(endpoint, values);

	return data;
};
